export default __webpack_public_path__ + "static/media/The_role_of_digital_health_in_expanding_access_to_sexual_and_reproductive_health_services.78cc257c.png";